import React from 'react';

const SvgMenu = ({ svgRef, title, ...props }) => (
  <svg width="1em" height="1em" viewBox="0 0 20 15" ref={svgRef} {...props}>
    <title>{title}</title><path fill="#fff" d="M0 15.001h3v-3H0zm5 0h14.999v-3H5zm-5-6h3v-3H0zm5 0h14.999v-3H5zm-5-6h3V0H0zm5 0h14.999V0H5z"/>
  </svg>
);

const ForwardRef = React.forwardRef((props, ref) => <SvgMenu svgRef={ref} {...props} />);
export default ForwardRef;



// WEBPACK FOOTER //
// ./src/common/icons/Menu.js